import { ReactNode } from 'react';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Body, Stack } from '@optimus-web/core';
import { SmsUsaRegistrationStatus } from '@mews-commander/data-access';
import { TextMessagingLabel } from '../../Typography';
import { BrandRegistrationTag } from './BrandRegistrationStatus/BrandRegistrationTag';
import { CampaignRegistrationTag } from './CampaignRegistrationStatus/CampaignRegistrationTag';
import { RegistrationHeadingStatus } from './RegistrationHeadingStatus';
import { RegistrationError } from './RegistrationError';

interface RegistrationBodyProps {
    registrationStatus: SmsUsaRegistrationStatus;
    setActive: (active: boolean) => void;
}

export const RegistrationBody = ({ registrationStatus, setActive }: RegistrationBodyProps) => {
    const isRegistrationInProgress = ![
        SmsUsaRegistrationStatus.BrandRegistrationNone,
        SmsUsaRegistrationStatus.CampaignRegistrationVerified,
    ].includes(registrationStatus);

    const registrationStatuses = isRegistrationInProgress ? (
        <Stack vertical spacing="100">
            <RegistrationRow
                label={TextKey.BrandRegistration}
                tag={<BrandRegistrationTag registrationStatus={registrationStatus} />}
            />
            <RegistrationRow
                label={TextKey.CampaignRegistration}
                tag={<CampaignRegistrationTag registrationStatus={registrationStatus} />}
            />
        </Stack>
    ) : null;

    return (
        <Stack vertical spacing="200">
            <Stack distribution="space-between" spacing="25" itemAlignment="center">
                <TextMessagingLabel as="p">
                    <LocalizedText textKey={TextKey.CountryUS} />
                </TextMessagingLabel>
                <RegistrationHeadingStatus
                    registrationStatus={registrationStatus}
                    onRegisterClick={() => setActive(true)}
                />
            </Stack>
            <RegistrationError registrationStatus={registrationStatus} />
            {registrationStatuses}
        </Stack>
    );
};

interface RegistrationRowProps {
    label: Mews.TextKey;
    tag: ReactNode;
}

const RegistrationRow = ({ label, tag }: RegistrationRowProps) => (
    <Stack distribution="space-between" spacing="25" itemAlignment="center">
        <Body size="small" variant="secondary">
            <LocalizedText textKey={label} />
        </Body>
        {tag}
    </Stack>
);
